export const environment = {
  production: false,
  // clientId: "200050510075-cr8tael5eut2jvkss1qp3mv79g1qlmch.apps.googleusercontent.com",
  clientId: "200050510075-8j1i7kmsmfd8vfe4145l8i8ts4q5e396.apps.googleusercontent.com",
  // javaUrl: "https://pristyn-java-staging-1025160438.ap-south-1.elb.amazonaws.com/"
  // javaUrl: "https://java-staging.pristoncare.com/"
  javaUrl: "https://pristyntech.com/",
  dashboardUrl: "https://partner.pristyntech.com"
};
